'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * React hook to copy string data to a users' clipboard via Clipboard API.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API
 *
 * @param options UseClipboardOptions | undefined
 * @returns UseClipboardReturn
 */ const useClipboard = (options = {})=>{
    const { delay =2000  } = options;
    const [copied, setCopied] = React.useState(false);
    const [copiedTimout, setCopiedTimout] = React.useState(undefined);
    // this is a boolean and not a `string` or `Error` so that
    // downstream apps handle their own translation(s)
    const [error, setError] = React.useState(false);
    const [errorTimout, setErrorTimout] = React.useState(undefined);
    const handleCopied = ()=>{
        if (delay > 0) {
            setCopied(true);
            clearTimeout(copiedTimout);
            setCopiedTimout(setTimeout(()=>{
                setCopied(false);
            }, delay));
        }
    };
    const handleErrored = ()=>{
        if (delay > 0) {
            setError(true);
            clearTimeout(errorTimout);
            setErrorTimout(setTimeout(()=>{
                setError(false);
            }, delay));
        }
    };
    const reset = ()=>{
        clearTimeout(copiedTimout);
        clearTimeout(errorTimout);
        setCopied(false);
        setError(false);
    };
    const handleCopy = async (data)=>{
        reset();
        try {
            await navigator.clipboard.writeText(data);
            handleCopied();
        } catch  {
            handleErrored();
        }
    };
    const copy = (data)=>{
        if (navigator.clipboard) {
            handleCopy(data);
        } else {
            handleErrored();
        }
    };
    return {
        copied,
        copy,
        error,
        reset
    };
};

exports.useClipboard = useClipboard;
//# sourceMappingURL=use-clipboard.js.map
